export const baseUrl = 'https://raw.githubusercontent.com/BSData/age-of-sigmar-4th/main/';

export const factionNames = [
  'Beasts of Chaos',
  'Blades of Khorne',
  'Bonesplitterz',
  'Cities of Sigmar',
  'Daughters of Khaine',
  'Disciples of Tzeentch',
  'Flesh-eater Courts',
  'Fyreslayers',
  'Gloomspite Gitz',
  'Hedonites of Slaanesh',
  'Idoneth Deepkin',
  'Ironjawz',
  'Kharadron Overlords',
  'Kruleboyz',
  'Lumineth Realm-lords',
  'Maggotkin of Nurgle',
  'Nighthaunt',
  'Ogor Mawtribes',
  'Orruk Warclans',
  'Ossiarch Bonereapers',
  'Seraphon',
  'Skaven',
  'Slaves to Darkness',
  'Sons of Behemat',
  'Soulblight Gravelords',
  'Stormcast Eternals',
  'Sylvaneth',
];